export const syncTypes = {
    ADD_ISSUE: 'newIssue',
    UPDATE_OPERATING_DATA: 'updateOperatingTime',
    ADD_CHECK_PERIOD: 'addCheckPeriod',
}

export interface SQLiteInstance {
    transaction: (callback: (tx: any) => void, error?: (e: any) => void, success?: () => void) => void;
    executeSql: (sql: string, params: any[], success: (res: any) => void, error?: (e: any) => void) => void;
}